export default __webpack_public_path__ + "static/media/kidscinema.de196812.png";